import { Alert, Button } from "antd";
import { useState } from "react"
import { v4 as uuidv4 } from 'uuid';

type AlertType = {
    type: 'success' | 'error' | 'warning' | 'info';
    message: string;
    description?: string;
    key?: string;
    onClose?: () => void;
}
let alerts: AlertType[] = [
];
let _setAlert: (alert: AlertType) => void;
let _clearAlerts: () => void;

const StaticAlert = () => {
    const [alertList, setAlertList] = useState<AlertType[]>(alerts);
    _setAlert = (alert: AlertType) => {
        const nextAlert = { ...alert, key: uuidv4() };
        alerts = [...alerts, nextAlert];
        setAlertList(alerts);
    };
    _clearAlerts = () => {
        alerts = [];
        setAlertList([]);
    };
    const onClose = (key?: string) => {
        alerts = alerts.filter(v => v.key !== key);
        setAlertList(alerts);
    };
    return <>
        {alertList.length > 0 && <Button size="small" onClick={_clearAlerts} style={{ margin: '6px 8px' }}>清除全部</Button>}
        {alertList.map((alert: AlertType) => {
            return <Alert key={alert.key} message={alert.message} description={alert.description} type={alert.type} showIcon closable={true} onClose={() => onClose(alert.key)} />
        })}
    </>
}

export { _setAlert, _clearAlerts };
export default StaticAlert;
